import { useAuth } from './useAuth';
import { useOrgConfig } from './useOrgConfig';

export interface Permissions {
  isAdmin: boolean;
  isManager: boolean;
  userCanEdit: boolean;
  userCanAdd: boolean;
  userCanRetire: boolean;
  userCanClassify: boolean;
  userCanArchive: boolean;
}

export function usePermissions(): Permissions {
  const { user } = useAuth();
  const { config } = useOrgConfig();

  const role = user?.role ?? 'user';
  const isAdmin = role === 'admin';
  const isQM = role === 'quartermaster';
  const isManager = isAdmin || isQM;
  const org = config?.organization;

  // Admin always has full permissions
  // QM checks qm_can_* fields
  // Standard user checks user_can_* fields
  const resolve = (
    qmField: boolean | undefined,
    userField: boolean | undefined,
  ): boolean => {
    if (isAdmin) return true;
    if (isQM) return qmField ?? true;
    return userField ?? false;
  };

  return {
    isAdmin,
    isManager,
    userCanEdit: resolve(org?.qm_can_edit_own_gear, org?.user_can_edit_own_gear),
    userCanAdd: resolve(org?.qm_can_add_gear, org?.user_can_add_gear),
    userCanRetire: resolve(org?.qm_can_retire_own_gear, org?.user_can_retire_own_gear),
    userCanClassify: resolve(org?.qm_can_change_classification, org?.user_can_change_classification),
    userCanArchive: resolve(org?.qm_can_archive_own_gear, org?.user_can_archive_own_gear),
  };
}
